import { FileTypes } from 'common/constants/filetypes';

export type ResourceLink = {
  type?: number;
  object_key?: string;
  name?: string;
  id?: number;
};

const getYouTubeVideoId = (url?: string): string | null => {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname.toLowerCase();
    const pathname = parsed.pathname || '';

    if (hostname === 'youtu.be') {
      const videoId = pathname.replace(/^\//, '');
      return videoId || null;
    }

    if (hostname.endsWith('youtube.com')) {
      if (pathname.startsWith('/watch')) {
        return parsed.searchParams.get('v');
      }

      if (pathname.startsWith('/embed/')) {
        return pathname.split('/')[2] || null;
      }
    }

    return null;
  } catch {
    return null;
  }
};

export const isYouTubeWatchUrl = (url?: string): boolean => Boolean(getYouTubeVideoId(url));

export const getYouTubeEmbedUrl = (url?: string): string | null => {
  const videoId = getYouTubeVideoId(url);
  if (!videoId) return null;

  return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
};

export type OpenResourceLinkCallbacks = {
  recordLinkOpen?: (url: string, resourceName?: string, repositoryFileId?: number) => void;
  openInApp?: () => void;
  openInNewTab?: (url: string) => void;
};

export const openResourceLink = (
  resource: ResourceLink,
  callbacks: OpenResourceLinkCallbacks
): void => {
  const { recordLinkOpen, openInApp, openInNewTab } = callbacks;
  const isLink = resource.type === FileTypes.URL && Boolean(resource.object_key);

  if (isLink && resource.object_key) {
    recordLinkOpen?.(resource.object_key, resource.name, resource.id);
  }

  if (isLink && isYouTubeWatchUrl(resource.object_key)) {
    openInApp?.();
    return;
  }

  if (isLink && resource.object_key) {
    if (openInNewTab) {
      openInNewTab(resource.object_key);
    } else {
      window.open(resource.object_key, '_blank', 'noopener');
    }
    return;
  }

  openInApp?.();
};
